/* eslint-disable no-eval */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/heading-has-content */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'common/Button';

// eslint-disable-next-line
const RawHtml = ({ children, type, buttonType, ...rest }) => {
  const props = {
    dangerouslySetInnerHTML: { __html: children },
    ...rest,
  };
  useEffect(() => {
    const doc = new DOMParser().parseFromString(children, 'text/html');
    const scripts = doc.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i += 1) {
      window.eval(scripts[i].innerText);
    }
  }, [children]);

  if (!children) {
    return '';
  }

  switch (type) {
    case 'p':
      return <p {...props} />;
    case 'span':
      return <span {...props} />;
    case 'strong':
      return <strong {...props} />;
    case 'h1':
      return <h1 {...props} />;
    case 'h2':
      return <h2 {...props} />;
    case 'h3':
      return <h3 {...props} />;
    case 'h4':
      return <h4 {...props} />;
    case 'small':
      return <small {...props} />;
    case 'label':
      return <label {...props} />;
    case 'legend':
      return <legend {...props} />;
    case 'button':
      return <Button type={buttonType} {...props} />;
    case 'a':
      return <a {...props} />;
    default:
      return <div {...props} />;
  }
};

RawHtml.propTypes = {
  buttonType: PropTypes.string,
  children: PropTypes.string,
  type: PropTypes.string,
};

RawHtml.defaultProps = {
  buttonType: 'button',
  children: '',
  type: '',
};

export default RawHtml;
